import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = useCallback((path: string) => location.pathname === path, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || location.pathname !== '/'
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl text-primary-600">韩漫</span>
            <span className="hidden sm:inline text-sm text-foreground-500 font-label">漫画大全</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                isActive('/') ? 'text-primary-600 font-medium' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-600 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                isActive('/about') ? 'text-primary-600 font-medium' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-base"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className={`py-3 px-3 rounded-lg text-sm font-label ${isActive('/') ? 'bg-primary-50 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'}`}>首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`py-3 px-3 rounded-lg text-sm font-label ${location.pathname.includes(cat.slug) ? 'bg-primary-50 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className={`py-3 px-3 rounded-lg text-sm font-label ${isActive('/about') ? 'bg-primary-50 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'}`}>关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}